import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
import * as serviceWorker from './serviceWorker';

const initialState = {
  language: 'EN',
};

const store = createStore(
  reducers,
  initialState
);

ReactDOM.render(
<Provider store={store}>
  <App />
</Provider>, document.getElementById('root'));

serviceWorker.unregister();
